import AnalysingBadge from './AnalysingBadge';
import PrivateBadge from './PrivateBadge';
import Settings from './Settings';
import DateController from './DateController';

const Header = () => {
  return (
    <div
      className='px-6 py-5 md:py-0 flex flex-col md:flex-row justify-between gap-3.5'
      style={{
        minHeight: '44px',
        borderBottom: 'thin solid #D1D1D1',
      }}
    >
      <DateController />
      <div className='flex flex-col md:flex-row gap-3.5'>
        <div className='
            flex flex-wrap gap-3.5
            md:flex-nowrap md:overflow-hidden
            items-center justify-center
          '
        >
          <AnalysingBadge />
          <PrivateBadge />
        </div>
        <Settings />
      </div>
    </div>
  );
};

export default Header;
